import { Controller } from "@hotwired/stimulus"

/**
 * Stimulus controller that makes datetime-local inputs open the picker on click.
 *
 * By default, some browsers only open the date picker when clicking the calendar icon.
 * This controller ensures clicking anywhere on the input opens the picker.
 *
 * Usage:
 *   <input type="datetime-local" data-controller="datetime-picker" data-action="click->datetime-picker#open">
 *
 * @example
 *   <%= form.datetime_local_field :event_date,
 *       data: { controller: "datetime-picker", action: "click->datetime-picker#open" } %>
 */
export default class extends Controller {
  /**
   * Opens the native date/time picker when the input is clicked.
   * Uses the modern showPicker() API with fallback for older browsers.
   *
   * @param {Event} event - The click event
   * @returns {void}
   */
  open(event) {
    const input = event.currentTarget

    // Check if showPicker() is supported (modern browsers)
    if (typeof input.showPicker === "function") {
      try {
        input.showPicker()
      } catch (error) {
        // Some browsers throw if already open or if not user-initiated
        // This is expected behavior, silently ignore
      }
    }
    // For older browsers, clicking the input naturally focuses it
    // The native picker behavior will vary by browser
  }
}

